import * as Website from '../../Config/Website.js';
import * as JobguideParallax from './Modules/JobguideParallax.js';


const preinit = () => {

}

const init = () => {
  JobguideParallax.init();
}

const pageChanged = () => {
  JobguideParallax.init();
}

const resize = () => {
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}